var map = {
	"./admin_settings.png": 1811,
	"./appraisals.png": 1812,
	"./catalog.png": 1813,
	"./catalogWhite.png": 1814,
	"./catalog_orders.png": 1815,
	"./cms.png": 1816,
	"./component-fields/Asset.png": 1817,
	"./component-fields/Blocks.png": 1818,
	"./component-fields/Boolean.png": 1819,
	"./component-fields/Date-time.png": 1820,
	"./component-fields/LInk.png": 1821,
	"./component-fields/Markdown.png": 1822,
	"./component-fields/Multi asset.png": 1823,
	"./component-fields/Multi options.png": 1824,
	"./component-fields/Number.png": 1825,
	"./component-fields/Richtext.png": 1826,
	"./component-fields/Single options.png": 1827,
	"./component-fields/Table.png": 1828,
	"./component-fields/Text area.png": 1829,
	"./component-fields/Text.png": 1830,
	"./components.png": 1831,
	"./configuration.png": 1832,
	"./contents.png": 1833,
	"./crm.png": 1834,
	"./custom_order.png": 1835,
	"./customer_credits.png": 1836,
	"./customer_list.png": 1837,
	"./dashboard.png": 1838,
	"./finance.png": 1839,
	"./home.png": 1840,
	"./integrations.png": 1841,
	"./inventory-transfers.png": 1842,
	"./invoice-list.png": 1843,
	"./layaway.png": 1844,
	"./move.png": 1845,
	"./new_sale.png": 1846,
	"./orders.png": 1847,
	"./outgoing-consignments.png": 1848,
	"./payment-methods/amex.png": 1198,
	"./payment-methods/discover.png": 1197,
	"./payment-methods/mastercard.png": 1196,
	"./payment-methods/visa.png": 1195,
	"./payments.png": 1849,
	"./plus.png": 1330,
	"./register.png": 1850,
	"./repair_center.png": 1851,
	"./reports.png": 1852,
	"./services.png": 1853,
	"./trade_in_center.png": 1854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1677;